
import { MdDeleteForever } from 'react-icons/md';
interface CardProps {
    text: string,
    icone: any,
    visualizado: number,
    onDelete: () => void,
    dataNotifi: string
}

export function CardNotificacao(props: CardProps) {

    return (
        <li className={props.visualizado !== 0 ? "container-notificacao-item visualizado-notifi" : "container-notificacao-item"}>
            <div className="text-area-notification">
                <span className="text-area-notificacao-item">{props.text}</span>
                <span className="text-area-notificacao-item">{props.dataNotifi}</span>
            </div>
            <span className="icone-area-notificacao-item">{props.icone}</span>
            <div className="btn-close-notifi-area">
                <button type="button" onClick={props.onDelete}><MdDeleteForever size={22} color='rgb(170, 46, 46)' /></button>
            </div>
        </li>
    )
}